import logo from './logo.svg';
import './App.css';
import Input from './component/Input';
import Display from './component/Display';
import Weather from './component/Weather';
function App() {
  return (
    <div className="App">
     <h1>Weather Forecasting App</h1>
    <Weather/>
    
    </div>
  );
}

export default App;
